import React, { useState } from "react";
import "./MyLoyalty.css";
import Exp7 from "../../assets/icons/Exp-7.-S.svg";
import { Link } from "react-router-dom";
import ProfileLayout from "../../components/profilelayout/ProfileLayout";
import FallbackImg from "../../components/FallbackImg";

const MyLoyalty = () => {
  const min = 0;
  const max = 20000;
  const [currSpent] = useState(11000); // static for now, can be dynamic
  const [activeTab, setActiveTab] = useState("credithistory");

  return (
    <ProfileLayout>
      <div className="myloyalty">
        <div className="myloyalty-content">
          <div className="myloyalty-title">
            <strong>MY LOYALTY</strong>
          </div>

          <div className="myloyalty-main">
            <Link to="/membertier">
              <div className="loyalty-exp">
                <FallbackImg src={Exp7} alt="exp7" width="32" height="32" />
                Platinum &gt; 
              </div>
            </Link>

            <input
              type="range"
              className="loyalty-slider no-thumb"
              min={min}
              max={max}
              value={currSpent}
              readOnly
              tabIndex={-1}
              aria-hidden="true"
              style={{
                "--value": currSpent,
                "--min": min,
                "--max": max,
              }}
            />

            <div className="loyalty-progress">
              <div className="loyalty-descrip">
                Spend RM 9,000 to unlock the next achievement &gt;
              </div>
              <div className="loyalty-currspent">
                RM {currSpent.toLocaleString()} / RM {max.toLocaleString()}
              </div>
            </div>
          </div>

          <div className="myloyalty-sub">
            <div
              className={`credithistory${
                activeTab === "credithistory" ? " active-tab" : ""
              }`}
              onClick={() => setActiveTab("credithistory")}
            >
              Credit History
            </div>
            <div
              className={`currentbenefit${
                activeTab === "currentbenefit" ? " active-tab" : ""
              }`}
              onClick={() => setActiveTab("currentbenefit")}
            >
              Current Benefit
            </div>
          </div>

          <div className="myloyalty-line"></div>

          <div className="myloyalty-sub2">
            {/* Credit History */}
            {activeTab === "credithistory" && (
              <div className="crhistory-item">
                <div className="incentive-container">
                  <div className="crhistory-incentive">
                    <strong>Incentive</strong>
                  </div>
                  <div className="crhistory-date">13 Dec 2024, 12:16</div>
                </div>
                <div className="tier-container">
                  <div className="crhistory-tier">Unlock Platinum tier</div>
                  <div className="crhistory-amount">
                    <strong>+ RM 50.00</strong>
                  </div>
                </div>
              </div>
            )}

            {/* Current Benefit */}
            {activeTab === "currentbenefit" && (
              <div className="currbenefit-item">
                <div className="currbenefit-name">
                  <strong>Exclusive Discounts</strong>
                </div>
                <div className="currbenefit-descrip">
                  Enjoy up to 20% off on selected products or services
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </ProfileLayout>
  );
};

export default MyLoyalty;
